const screens = [
  {
    title: 'Smart Dashboard',
    description: 'Everything at a glance',
    content: (
      <div className="h-full bg-gradient-to-b from-grass-600 to-grass-700 relative overflow-hidden">
        {/* Background blur */}
        <div className="absolute top-10 right-0 w-32 h-32 bg-grass-400/30 rounded-full blur-2xl" />

        {/* Status bar */}
        <div className="flex justify-between items-center px-5 pt-2 text-[10px] text-white/70">
          <span className="font-semibold">9:41</span>
          <div className="flex items-center gap-1">
            <div className="w-4 h-2 bg-white/60 rounded-sm" />
          </div>
        </div>

        {/* Header */}
        <div className="px-5 pt-3 pb-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-white/60 text-[10px] font-medium">
                Good morning
              </div>
              <div className="text-white text-base font-bold">My Lawn</div>
            </div>
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <svg
                className="w-4 h-4 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Main Card */}
        <div className="mx-3 bg-white rounded-[20px] shadow-xl overflow-hidden">
          {/* Score Section */}
          <div className="p-4 pb-3">
            <div className="flex items-center gap-3">
              <div className="relative w-16 h-16">
                <svg className="w-16 h-16 -rotate-90" viewBox="0 0 36 36">
                  <circle
                    cx="18"
                    cy="18"
                    r="14"
                    fill="none"
                    stroke="#f0fdf4"
                    strokeWidth="4"
                  />
                  <circle
                    cx="18"
                    cy="18"
                    r="14"
                    fill="none"
                    stroke="url(#grad1)"
                    strokeWidth="4"
                    strokeDasharray="77 100"
                    strokeLinecap="round"
                  />
                  <defs>
                    <linearGradient id="grad1">
                      <stop offset="0%" stopColor="#22c55e" />
                      <stop offset="100%" stopColor="#16a34a" />
                    </linearGradient>
                  </defs>
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-xl font-black text-gray-900">87</span>
                </div>
              </div>
              <div className="flex-1">
                <div className="text-sm font-bold text-gray-900">Excellent</div>
                <div className="text-[10px] text-gray-500">
                  Front Yard Health
                </div>
                <div className="mt-1 inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-grass-100 rounded text-[9px] font-semibold text-grass-700">
                  <svg
                    className="w-2 h-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  +5
                </div>
              </div>
            </div>
          </div>

          {/* Stats Row */}
          <div className="grid grid-cols-3 border-t border-gray-100">
            <div className="p-3 text-center border-r border-gray-100">
              <div className="text-base font-bold text-gray-900">3</div>
              <div className="text-[9px] text-gray-500">Tasks</div>
            </div>
            <div className="p-3 text-center border-r border-gray-100">
              <div className="text-base font-bold text-sky-500">72°</div>
              <div className="text-[9px] text-gray-500">Today</div>
            </div>
            <div className="p-3 text-center">
              <div className="text-base font-bold text-sunset-500">2d</div>
              <div className="text-[9px] text-gray-500">Rain</div>
            </div>
          </div>

          {/* Next Task */}
          <div className="p-3 bg-grass-50 border-t border-grass-100">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-grass-500 rounded-lg flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <div className="text-[11px] font-semibold text-gray-900">
                  Water Tomorrow
                </div>
                <div className="text-[9px] text-gray-500">6:00 AM optimal</div>
              </div>
              <svg
                className="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: 'AI Analysis',
    description: 'Instant weed identification',
    content: (
      <div className="h-full bg-gray-50 relative overflow-hidden">
        {/* Status bar */}
        <div className="flex justify-between items-center px-5 pt-2 text-[10px] text-gray-600 bg-white">
          <span className="font-semibold">9:41</span>
          <div className="flex items-center gap-1">
            <div className="w-4 h-2 bg-gray-400 rounded-sm" />
          </div>
        </div>

        {/* Header */}
        <div className="px-5 py-3 bg-white border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 bg-gray-100 rounded-full flex items-center justify-center">
              <svg
                className="w-4 h-4 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </div>
            <div className="text-sm font-bold text-gray-900">AI Analysis</div>
          </div>
        </div>

        {/* Photo Area - Lawn closeup with weed */}
        <div className="mx-4 mt-3 rounded-2xl overflow-hidden shadow-lg relative">
          <div className="aspect-square relative overflow-hidden">
            {/* Grass texture background */}
            <div className="absolute inset-0 bg-grass-600" />
            {/* Grass blade pattern */}
            <svg
              className="absolute inset-0 w-full h-full opacity-60"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
            >
              {[...Array(20)].map((_, i) => (
                <path
                  key={i}
                  d={`M${5 + i * 5} 100 Q${3 + i * 5} ${60 + Math.random() * 20} ${4 + i * 5 + Math.random() * 2} ${30 + Math.random() * 10}`}
                  stroke="#22c55e"
                  strokeWidth="2"
                  fill="none"
                />
              ))}
            </svg>
            {/* Weed in center - dandelion style */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <svg className="w-16 h-16" viewBox="0 0 64 64">
                {/* Weed leaves */}
                <path
                  d="M32 40 Q28 35 24 42 Q20 38 18 44"
                  stroke="#84cc16"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M32 40 Q36 35 40 42 Q44 38 46 44"
                  stroke="#84cc16"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M32 40 Q30 32 26 36"
                  stroke="#84cc16"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M32 40 Q34 32 38 36"
                  stroke="#84cc16"
                  strokeWidth="2"
                  fill="none"
                />
                {/* Yellow flower */}
                <circle cx="32" cy="24" r="8" fill="#fbbf24" />
                <circle cx="32" cy="24" r="4" fill="#f59e0b" />
              </svg>
            </div>
            {/* Focus corners */}
            <div className="absolute top-3 left-3 w-6 h-6 border-l-2 border-t-2 border-white/90 rounded-tl" />
            <div className="absolute top-3 right-3 w-6 h-6 border-r-2 border-t-2 border-white/90 rounded-tr" />
            <div className="absolute bottom-3 left-3 w-6 h-6 border-l-2 border-b-2 border-white/90 rounded-bl" />
            <div className="absolute bottom-3 right-3 w-6 h-6 border-r-2 border-b-2 border-white/90 rounded-br" />
            {/* Detection circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 border-2 border-sunset-400 rounded-full animate-pulse" />
          </div>
        </div>

        {/* Results Card */}
        <div className="mx-4 mt-3 bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-3 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-yellow-600"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <div className="flex-1">
                <div className="text-[11px] font-bold text-gray-900">
                  Dandelion Identified
                </div>
                <div className="text-[9px] text-gray-500">
                  92% confidence • Common weed
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 bg-grass-50">
            <div className="text-[10px] font-semibold text-grass-800 mb-1">
              Easy to Remove
            </div>
            <div className="text-[9px] text-grass-600">
              Tap for removal guide & products
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: 'Care Calendar',
    description: 'Never miss a task',
    content: (
      <div className="h-full bg-white relative overflow-hidden">
        {/* Status bar */}
        <div className="flex justify-between items-center px-5 pt-2 text-[10px] text-gray-600">
          <span className="font-semibold">9:41</span>
          <div className="flex items-center gap-1">
            <div className="w-4 h-2 bg-gray-400 rounded-sm" />
          </div>
        </div>

        {/* Header */}
        <div className="px-5 py-3">
          <div className="flex items-center justify-between">
            <div className="text-base font-bold text-gray-900">January</div>
            <div className="flex gap-1">
              <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center">
                <svg
                  className="w-3 h-3 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </div>
              <div className="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center">
                <svg
                  className="w-3 h-3 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Calendar Grid */}
        <div className="px-4">
          <div className="grid grid-cols-7 gap-0.5 text-center mb-2">
            {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => (
              <div
                key={i}
                className="text-[9px] font-medium text-gray-400 py-1"
              >
                {d}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-0.5 text-center">
            {[...Array(31)].map((_, i) => {
              const isToday = i === 17;
              const hasTask = i === 20 || i === 24 || i === 28;
              return (
                <div
                  key={i}
                  className={`py-1.5 text-[10px] font-medium rounded-lg relative ${
                    isToday
                      ? 'bg-grass-500 text-white'
                      : hasTask
                        ? 'bg-grass-50 text-grass-700'
                        : 'text-gray-700'
                  }`}
                >
                  {i + 1}
                  {hasTask && !isToday && (
                    <div className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 bg-grass-500 rounded-full" />
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Upcoming Tasks */}
        <div className="px-4 mt-4">
          <div className="text-[10px] font-semibold text-gray-500 mb-2">
            UPCOMING
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-grass-100 rounded-lg flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-grass-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <div className="text-[10px] font-semibold text-gray-900">
                  Apply Fertilizer
                </div>
                <div className="text-[9px] text-gray-500">Jan 21 • Morning</div>
              </div>
            </div>
            <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-sky-100 rounded-lg flex items-center justify-center">
                <svg
                  className="w-4 h-4 text-sky-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  />
                </svg>
              </div>
              <div className="flex-1">
                <div className="text-[10px] font-semibold text-gray-900">
                  Overseed Bare Spots
                </div>
                <div className="text-[9px] text-gray-500">
                  Jan 25 • Afternoon
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ),
  },
];

function AppPreview() {
  return (
    <section id="preview" className="section-padding bg-white">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Simple, <span className="gradient-text">Powerful</span>, Beautiful
          </h2>
          <p className="text-lg text-gray-600">
            An app that makes lawn care feel effortless. Track your progress,
            get AI insights, and follow your personalized care calendar.
          </p>
        </div>

        {/* App preview */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {screens.map((screen, index) => (
            <div key={index} className="text-center">
              {/* Phone frame */}
              <div className="relative mx-auto max-w-[260px]">
                <div className="bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl">
                  <div className="bg-gray-800 rounded-[2rem] overflow-hidden">
                    {/* Notch */}
                    <div className="relative bg-black h-6 flex items-center justify-center">
                      <div className="w-16 h-4 bg-black rounded-b-xl" />
                    </div>
                    {/* Screen content */}
                    <div className="aspect-[9/16] overflow-hidden">
                      {screen.content}
                    </div>
                  </div>
                  {/* Home indicator */}
                  <div className="flex justify-center pt-1 pb-0.5">
                    <div className="w-20 h-1 bg-gray-600 rounded-full" />
                  </div>
                </div>
              </div>

              {/* Caption */}
              <div className="mt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {screen.title}
                </h3>
                <p className="text-gray-500">{screen.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AppPreview;
